import { jsx as _jsx } from "react/jsx-runtime";
import { getOrderStatusLabel } from "@/utils/orderHelpers";
import { getOrderStatusColor } from "@/utils/orderHelpers";
import { Tag } from "antd";
export const OrderStatusTag = ({ status, }) => {
    if (!status)
        return null;
    return (_jsx(Tag, { color: getOrderStatusColor(status), children: getOrderStatusLabel(status) }));
};
